import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

// Empty access control - allows all users
export const retailerContactViewAccessControl: DomainAccessControlConfig = {}

export const retailerContactModifyAccessControl: DomainAccessControlConfig = {}

export const retailerContactAccessControl: DomainAccessControlConfig = {
  warehouseFeatureToggles: [FeatureToggle.retailerContact],
}
